import SimpleBar from 'simplebar';

const moduleName = 'scrollPanel';

export function scrollPanel () {
    function setScrollbarClass(wrap){
        if(wrap.querySelector('.simplebar-vertical').style.visibility === 'visible'){
            wrap.classList.add('_has-scrollbar');
        }else{
            wrap.classList.remove('_has-scrollbar');
        }
    }

    const scrollPanels = Array.from(document.querySelectorAll('.js-scroll'));

    scrollPanels.forEach((self) => {
        new SimpleBar(self);
        setScrollbarClass(self);
    });

    window.addEventListener('resize', function (){
        scrollPanels.forEach((self) => {
            setScrollbarClass(self);
        });
    });


    window.SimpleBar = SimpleBar;
}
